<template>
<!--  <div class="app-body">-->
<!--    <el-form-->
<!--        :inline="true"-->
<!--        :model="queryForm"-->
<!--        @keyup.enter.native="$refs.table.getDataList()"-->
<!--        ref="queryForm"-->
<!--        class="query-form"-->
<!--    >-->
<!--      <el-form-item prop="orderCode" label="外销合同号：">-->
<!--        <el-input-->
<!--            v-model="queryForm.orderCode"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入外销合同号"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="orderCode" label="出口发票号：">-->
<!--        <el-input-->
<!--            v-model="queryForm.boxReceiptCode"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入出口发票号"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="storeName" label="仓库：">-->
<!--        <el-input-->
<!--            v-model="queryForm.storeName"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入仓库名称"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="senderName" label="供应商：">-->
<!--        <el-input-->
<!--            v-model="queryForm.senderName"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入供应商名称"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="storeType" label="出入库类型：">-->
<!--        <el-select v-model="queryForm.storeType" size="mini" style="width: 100px;" clearable>-->
<!--          <el-option value="" label="全部"></el-option>-->
<!--          <el-option :value="1" label="入库"></el-option>-->
<!--          <el-option :value="-1" label="出库"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="reason" label="变动原因：">-->
<!--        <el-select v-model="queryForm.reason" size="mini" style="width: 100px;" clearable>-->
<!--          <el-option value="" label="全部"></el-option>-->
<!--          <el-option value="生产入库" label="生产入库"></el-option>-->
<!--          <el-option value="库存调配" label="库存调配"></el-option>-->
<!--          <el-option value="箱单入库" label="箱单入库"></el-option>-->
<!--          <el-option value="箱单出库" label="箱单出库"></el-option>-->
<!--          <el-option value="库存初始化" label="库存初始化"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="productCode" label="品番号：">-->
<!--        <el-input-->
<!--            v-model="queryForm.productCode"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入品番号"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="productName" label="品名：">-->
<!--        <el-input-->
<!--            v-model="queryForm.productName"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入品名"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="productColor" label="颜色：">-->
<!--        <el-input-->
<!--            v-model="queryForm.productColor"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入颜色"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="productSize" label="规格：">-->
<!--        <el-input-->
<!--            v-model="queryForm.productSize"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入规格"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="退货：" prop="isBack">-->
<!--        <el-select v-model="queryForm.isBack" size="mini" style="width: 100px;">-->
<!--          <el-option label="全部" value=""></el-option>-->
<!--          <el-option label="有退货" value="1"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="发票：" prop="hasReceipt">-->
<!--        <el-select v-model="queryForm.hasReceipt" size="mini" style="width: 100px;">-->
<!--          <el-option label="全部" value=""></el-option>-->
<!--          <el-option label="有发票" value="1"></el-option>-->
<!--          <el-option label="无发票" value="2"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="操作时间：" prop="beginDate">-->
<!--        <el-date-picker-->
<!--            v-model="queryForm.beginDate"-->
<!--            type="date"-->
<!--            size="mini"-->
<!--            value-format="yyyy-MM-dd"-->
<!--            placeholder="选择查询起始日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="" label-width="0px" prop="endDate">-->
<!--        <el-date-picker-->
<!--            v-model="queryForm.endDate"-->
<!--            type="date"-->
<!--            size="mini"-->
<!--            value-format="yyyy-MM-dd"-->
<!--            placeholder="选择查询截止日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="creatorName" label="操作人：">-->
<!--        <el-input-->
<!--            v-model="queryForm.creatorName"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入操作人姓名"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item prop="businessMan" label="业务担当：">-->
<!--        <el-input-->
<!--            v-model="queryForm.businessMan"-->
<!--            size="mini"-->
<!--            clearable-->
<!--            type="text"-->
<!--            placeholder="请输入业务担当"-->
<!--        ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item>-->
<!--        <el-button type="primary" @click="$refs.table.reload()" size="mini"-->
<!--        >查询-->
<!--        </el-button-->
<!--        >-->
<!--        <el-button @click="$refs.table.reset()" size="mini">重置</el-button>-->
<!--      </el-form-item>-->
<!--    </el-form>-->
<!--    <div class="tool-box">-->
<!--      <el-button class="tool-item" @click="uploadImg" type="warning" size="mini" v-if="$hasPermission('store:upload')">-->
<!--        上传凭证-->
<!--      </el-button>-->
<!--&lt;!&ndash;      <el-button class="tool-item" type="primary" size="mini" v-if="$hasPermission('erp:store:checkin')" @click="$refs.ProductCheckinImport.init()">&ndash;&gt;-->
<!--&lt;!&ndash;        成品入库批量导入&ndash;&gt;-->
<!--&lt;!&ndash;      </el-button>&ndash;&gt;-->
<!--      <el-checkbox v-model="showMakeBatchCode"  class="tool-item">显示加工批次号</el-checkbox>-->
<!--    </div>-->
<!--    <SweetTable ref="table" :selection="true" url="/erp/store/product/log/page" :query-form="queryForm" api-version="v2"-->
<!--                :summaries-column="['count']" :before-table-binding="beforeTableBinding">-->
<!--      <el-table-column-->
<!--          prop="orderCode"-->
<!--          label="合同编号"-->
<!--          fixed="left"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--          width="120px" :show-overflow-tooltip="true"-->
<!--      ></el-table-column>-->
<!--      <el-table-column-->
<!--          v-if="showMakeBatchCode"-->
<!--          prop="makeBatchCode"-->
<!--          label="加工批次号"-->
<!--          fixed="left"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--          width="120px" :show-overflow-tooltip="true"-->
<!--      ></el-table-column>-->
<!--      <el-table-column-->
<!--          prop="boxReceiptCode"-->
<!--          label="出口发票号"-->
<!--          fixed="left"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--          width="120px" :show-overflow-tooltip="true"-->
<!--      ></el-table-column>-->
<!--      <el-table-column-->
<!--          prop="sellerName"-->
<!--          fixed="left"-->
<!--          label="发货方"-->
<!--          width="120px"-->
<!--          :formatter="$c.companyNameFormatter"-->
<!--          :show-overflow-tooltip="true"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--      ></el-table-column>-->
<!--      <el-table-column-->
<!--          prop="storageName"-->
<!--          fixed="left"-->
<!--          label="仓库"-->
<!--          width="120px"-->
<!--          :formatter="$c.companyNameFormatter"-->
<!--          :show-overflow-tooltip="true"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--      ></el-table-column>-->

<!--      <el-table-column-->
<!--          label="发票号"-->
<!--          header-align="center"-->
<!--          align="center" width="120px"-->
<!--      >-->
<!--        <template #default="{row}">-->
<!--          <div v-for="r in row.receiptDetailList" :key="r.id">{{ r.receiptCode }}</div>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--          label="开票单价"-->
<!--          header-align="center"-->
<!--          align="center" width="80px"-->
<!--      >-->
<!--        <template #default="{row}">-->
<!--          <div v-for="r in row.receiptDetailList" :key="r.id">{{ r.price }}</div>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="product.code" label="品番号" :show-overflow-tooltip="true" width="120px"-->
<!--                       header-align="center"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="product.skuCode" label="SKU" header-align="center" :show-overflow-tooltip="true"-->
<!--                       width="120px"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="product.name" label="品名" header-align="center" :show-overflow-tooltip="true"-->
<!--                       width="120px"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="product.color" label="颜色" header-align="center" :show-overflow-tooltip="true"-->
<!--                       width="120px"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="product.size" label="规格" header-align="center" :show-overflow-tooltip="true"-->
<!--                       width="120px"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="product.nameZh" label="中文品名" header-align="center" :show-overflow-tooltip="true"-->
<!--                       width="120px"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="makeType" label="加工类型" header-align="center" width="80"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="reason" label="变动原因" header-align="center" width="80"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column prop="count" label="数量" header-align="center" width="100"-->
<!--                       align="center">-->
<!--        <template #default="{row}">-->
<!--          <div :style="{color:row.count>0?'#67C23A':'#F56C6C'}">-->
<!--            {{ row.count }}-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      &lt;!&ndash;      <el-table-column prop="price" label="收货价格"  header-align="center"  width="80"&ndash;&gt;-->
<!--      &lt;!&ndash;                       align="center"></el-table-column>&ndash;&gt;-->
<!--      <el-table-column prop="operateTime" label="出入库日期" width="100" header-align="center"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column label="图片" header-align="center"-->
<!--                       align="center">-->
<!--        <template #default="{row}">-->
<!--          <img-viewer v-if="row.imgs" :imgs="row.imgs"></img-viewer>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="updaterName" label="制单人" header-align="center" width="90px"-->
<!--                       :show-overflow-tooltip="true"-->
<!--                       align="center"></el-table-column>-->
<!--      <el-table-column label="制单时间" prop="createDate" width="160px" header-align="center"-->
<!--                       align="center">-->
<!--      </el-table-column>-->
<!--      <el-table-column label="备注" prop="remark" width="100px" header-align="center"-->
<!--                       align="center" :show-overflow-tooltip="true">-->
<!--      </el-table-column>-->
<!--&lt;!&ndash;      <el-table-column label="操作" fixed="right" header-align="center" width="120px"&ndash;&gt;-->
<!--&lt;!&ndash;                       align="center">&ndash;&gt;-->
<!--&lt;!&ndash;        <template #default="{row}">&ndash;&gt;-->
<!--&lt;!&ndash;          <el-button type="text" size="small" v-if="row.status==15" @click="checkReceipt(row)">确认价格</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-button type="text" size="small" v-if="$hasPermission('store:log:change_count')"&ndash;&gt;-->
<!--&lt;!&ndash;                     @click="$refs.ChangeCount.init(row.id,row.count)">修改数量&ndash;&gt;-->
<!--&lt;!&ndash;          </el-button>&ndash;&gt;-->
<!--&lt;!&ndash;        </template>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-table-column>&ndash;&gt;-->
<!--    </SweetTable>-->
<!--    <image-upload-dialog ref="ImageUploadDialog" @completed="uploadImgCompleted"></image-upload-dialog>-->
<!--    <ChangeCount ref="ChangeCount" @changed="$refs.table.getDataList()"></ChangeCount>-->
<!--    <common-upload ref="CommonUpload" upload-url="/erp/store/log/import/price"-->
<!--                   placeHolder="请严格按核价单导出EXCEL进行填写"></common-upload>-->
<!--    <common-upload ref="ProductCheckinImport" template-url="/static/template/成品批量入库.xlsx"-->
<!--                   upload-url="/trade/factorystorelog/checkin/import" version="v2"-->
<!--                   placeHolder="请严格按核价单导出EXCEL进行填写" @success="$refs.table.getDataList()"></common-upload>-->
<!--    <common-upload ref="DeleteImport"-->
<!--                   upload-url="/erp/store/import/delete" version="v2"-->
<!--                   @success="$refs.table.getDataList()"></common-upload>-->
<!--    <transfer-dialog ref="TransferDialog" @success="$refs.table.getDataList()" product-type="产品"></transfer-dialog>-->
<!--    <common-upload ref="CheckPriceImport"-->
<!--                   upload-url="/erp/store/import/price" version="v2"-->
<!--                   placeHolder="请严格按核价单导出EXCEL进行填写" @success="$refs.table.reload()"></common-upload>-->
<!--  </div>-->
</template>

<script>
import ChangeCount from '@/views/modules/StoreManager/common/ChangeCount.vue'
import ReceiptCheckDialog from '@/views/modules/StoreManager/receipt/check-dialog'
import ImgViewer from '@/components/ImgViewer'
import ImageUploadDialog from '@/components/ImageUploadDialog'
import SweetTable from '@/mixins/SweetTable'
import TransferDialog from './transfer-dialog.vue'

export default {
  mixins: [SweetTable],
  components: { ImgViewer, ImageUploadDialog, ReceiptCheckDialog, ChangeCount, TransferDialog },
  data () {
    return {
      showMakeBatchCode:false,
      queryForm: {
        boxReceiptCode: '',
        productCode: '',
        productType: this.$const.ProductType.PRODUCT,
        productName: '',
        orderCode: '',
        storeName: '',
        storeType: 1,
        senderName: '',
        isBack: '',
        hasReceipt: '',
        beginDate: '',
        endDate: '',
        creatorName: '',
        productColor: '',
        productSize: '',
        reason: '',
        businessMan: ''
      }
    }
  },
  computed: {},
  methods: {
    batchDelete () {
      let dataList = this.$refs[this.tableRef].dataListSelections
      if (this.$c.isArrayEmpty(dataList)) {
        return this.$message.error('请选择要删除的数据')
      }
      this.$api2.post(`/erp/store/product/del`, { ids: dataList.map(item => item.id) }).then(res => {
        this.$message.success('删除成功')
        this.clearSelection()
        this.getDataList()
      })
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.count = row.count * row.type
      })
    },
    downCheckFile () {
      this.$confirm(`核价单导出后相关记录将会锁定,是否继续?`).then(() => {
        this.$export(`/erp/store/log/export/check`, this.queryForm)
      })
    },
    showTransferDialog () {
      let rows = this.$refs.table.dataListSelections
      if (rows.length === 0) {
        return this.$message.error('请选择要调仓的批次')
      }
      const data = this.$clone(rows)
      let outStorageId = ''
      let validRes = true
      data.forEach((item) => {
        item.count = 0
        if (outStorageId == '') {
          outStorageId = item.storageId
        }
        if (outStorageId !== item.storageId) {
          validRes = false
        }
      })
      if (!validRes) {
        return this.$message.error('调出仓库不一致,请重新选择')
      }
      this.$refs.TransferDialog.dataForm.checkOutStorageId = outStorageId
      this.$refs.TransferDialog.dataForm.detailList = data
      this.$refs.TransferDialog.init()
    },
    doExport () {
      this.$export('/erp/store/log/export', this.queryForm)
    },
    showReceiptCheckDialog () {
      let rows = this.$refs.table.dataListSelections
      let checkInRow = rows.filter(r => r.type == 1)
      if (!checkInRow || checkInRow.length == 0) {
        return this.$message.error('请选择收货记录')
      }
      this.$refs.ReceiptCheckDialog.init(checkInRow)
    },
    // checkReceipt (row) {
    //   this.$confirm(`是否确认该价格,如驳回该价格可重新开票上传`, '操作提示', {
    //     confirmButtonText: '确认',
    //     cancelButtonText: '驳回',
    //     type: 'warning'
    //   }).then(() => {
    //     this.doCheckReceipt(row.id, 30)
    //   }).catch(() => {
    //     this.doCheckReceipt(row.id, 10)
    //   })
    // },
    // async doCheckReceipt (id, status) {
    //   const { data: res } = await this.$http.post(`/store/receipt/check`, { status: status, id: id })
    //   if (res.code !== 0) {
    //     return this.$message.error(res.msg)
    //   }
    //   this.$message.success('操作成功')
    //   this.$refs.table.getDataList()
    // },
    //上传图片凭证
    uploadImg () {
      let rows = this.$refs.table.dataListSelections
      if (rows.length === 0) {
        return this.$message.error('请选择出入库记录')
      }
      this.$refs.ImageUploadDialog.init()
    },
    //批量更新出入库记录图片
    uploadImgCompleted (imgs) {
      if (!imgs) {
        return this.$message.error('请上传图片')
      }
      let imgObj = JSON.parse(imgs)
      let rows = this.$refs.table.dataListSelections
      let ids = rows.map(item => item.id).join(',')
      this.$http.post(`/store/update/imgs`, { ids: ids, imgs: imgObj.join(',') }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功')
        this.$refs.table.clearSelection()
        this.$refs.table.getDataList()
        this.$refs.ImageUploadDialog.clear()
      })
    }
  },
}
</script>

<style scoped></style>
